<template>
  <div class="user-name ma-4">
    <h3 class="subtitle text-center">
      {{ getUserName }},
    </h3>
    <p class="text-center">detta provar vi idag:</p>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  computed: {
    getUserName () {
      return this.$store.getters.raterName
    }
  }
}
</script>
